import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosStep } from './step'
import { IcosSteps } from './steps'


@NgModule({
  declarations: [IcosStep, IcosSteps],
  exports: [IcosStep, IcosSteps],
  imports: [CommonModule],
  entryComponents: [IcosStep, IcosSteps],
})
export class IcosStepsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosStepsModule, providers: [] }
  }
}
